<template>
  <div>
    <div v-if="forms.length === 0" class="text-center py-12">
      <div class="text-gray-400 text-lg">No completed forms yet</div>
    </div>
    <div v-else class="bg-white shadow rounded-lg overflow-hidden">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Template</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Submitted By</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Completed</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <template v-for="form in forms" :key="form.id">
            <tr class="hover:bg-gray-50">
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="text-sm font-medium text-gray-900">{{ form.contactName }}</div>
                <div v-if="form.contactEmail" class="text-xs text-gray-500">{{ form.contactEmail }}</div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{{ templateName(form.templateId) }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{{ form.submittedBy || '—' }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(form.completedAt) }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-right">
                <button
                  @click="toggle(form.id)"
                  class="text-sm text-blue-600 hover:text-blue-800 font-medium"
                >{{ expanded[form.id] ? 'Hide' : 'View' }}</button>
              </td>
            </tr>
            <tr v-if="expanded[form.id]">
              <td colspan="5" class="px-6 py-4 bg-gray-50">
                <div class="space-y-1">
                  <div v-for="field in getTemplateFields(form.templateId)" :key="field.key" class="flex text-sm">
                    <span class="font-medium text-gray-600 w-48 shrink-0">{{ field.label }}:</span>
                    <span class="text-gray-800">{{ formatValue(field, form.responses?.[field.key]) }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompletedTable',
  props: {
    forms: { type: Array, required: true },
    templates: { type: Array, required: true }
  },
  data() {
    return { expanded: {} }
  },
  methods: {
    toggle(id) {
      this.expanded = { ...this.expanded, [id]: !this.expanded[id] }
    },
    templateName(id) {
      const t = this.templates.find(t => t.id === id)
      return t ? t.name : id
    },
    getTemplateFields(templateId) {
      const t = this.templates.find(t => t.id === templateId)
      return t ? t.fields : []
    },
    formatDate(iso) {
      if (!iso) return ''
      return new Date(iso).toLocaleDateString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit'
      })
    },
    formatValue(field, value) {
      if (value === undefined || value === null) return '—'
      if (field.type === 'checkbox') return value ? 'Yes' : 'No'
      if (field.type === 'multi_select' && Array.isArray(value)) return value.join(', ')
      return String(value)
    }
  }
}
</script>
